'use strict';

angular.module('shiftTraderApp')
  .service('NotesStore', ['$log', '$rootScope', 'Session', 'TimeService', 'Notes', '$q', '$timeout', '$interval',
    function ($log, $rootScope, Session, TimeService, Notes, $q, $timeout, $interval) {
      var records = [];

      var recordsDikt = {};
      var repliesDikt = {};

      var cacheAgeByDate = {};
      var maxCacheAgeInSeconds = 60;
      var cacheAgeKeyFormat = 'MM-DD-YYYY';

      var batches = [];

      var dataRequests = [];

      var rxSubject = new Rx.Subject();

      function createBatch(request) {
        var newBatch = {
          open: true,
          startTime: request.startTime,
          endTime: request.endTime,
          requests: [request],
          timeout: $timeout(function() {
            processBatch(newBatch);
          }, 50)
        };
        batches.push(newBatch);

        return newBatch
      }

      function createDataRequest(startTime, endTime, callback) {
        var request = {
          startTime: startTime,
          endTime: endTime,
          callback: callback
        };
        dataRequests.push(request);

        return request;
      }

      function createOrAddRequestToBatch(request) {
        // check to see if there are any batches that:
        // open = true OR there is any overlap between request startTime/endTime and batch startTime/endTime

        var matchingBatch = lodash.find(batches, function(batch) {
          var twx = batch.startTime.twix(batch.endTime);
          var reqTwix = request.startTime.twix(request.endTime);
          return batch.open &&
            ((reqTwix.overlaps(twx) && Math.abs(reqTwix.intersection(twx).length('minutes')) > 0)
            || batch.startTime.isSame(request.endTime, 'minute') || batch.endTime.isSame(request.startTime, 'minute'));
        });

        if (matchingBatch) {
          //console.log('BATCH: FOUND a batching batch', matchingBatch);
          $timeout.cancel(matchingBatch.timeout);
          var twx = matchingBatch.startTime.twix(matchingBatch.endTime);
          var reqTwix = request.startTime.twix(request.endTime);
          var union = twx.union(reqTwix);

          matchingBatch.startTime = union.start;
          matchingBatch.endTime = union.end;
          //console.log('BATCH: new batch times: ', matchingBatch.startTime.format(), matchingBatch.endTime.format());

          matchingBatch.requests.push(request);
          matchingBatch.timeout = $timeout(function() {
            processBatch(matchingBatch);
          }, 50);

        } else {
          var z = createBatch(request);
          //console.log('BATCH: CREATED NEW', z);
        }
      }

      function processBatch(batch) {
        batch.open = false;

        var startDate = TimeService.getBeginningOfDayFromDate(batch.startTime);

        // go to the end of the following day, just to make sure we include everything with dayStartHour
        var endDate = TimeService.getBeginningOfDayFromDate(batch.endTime).add(1, 'days');


        var data = {
          start_date: startDate.toISOString(),
          end_date: endDate.toISOString()
        };

        Notes.getAll(data)
          .then(function(notes) {
            that.updateCache(startDate, endDate, notes);

            lodash.each(batch.requests, function(request) {
              request.callback(request.startTime, request.endTime);
            });

          }, function() {
            lodash.each(batch.requests, function(request) {
              request.callback(undefined);
            })
          });
      }


      var that = this;

      this.flush = function(requery) {
        records = [];
        recordsDikt = {};
        repliesDikt = {};
        cacheAgeByDate = {};

        if (requery) {
          $rootScope.$broadcast('sa:notes:rerun-query');
        }
      };

      $rootScope.$on('flushCaches', function() {
        that.flush();
      });

      $rootScope.$on('updatedSessionMe', function() {
      });

      function canUseCacheForRange(startDate, endDate) {
        // returns simple true or false;
        // IF cache can be used then return true, otherwise return false

        var currDate = moment(startDate);
        var acceptablePreviousTime = moment.utc().subtract(maxCacheAgeInSeconds, 'seconds');

        //console.log('canUseCacheForRange', currDate.format(), acceptablePreviousTime.format());

        while (currDate.isBefore(endDate)) {
          var val = cacheAgeByDate[currDate.format(cacheAgeKeyFormat)];
          if (!val || (val.isBefore && val.isBefore(acceptablePreviousTime))) {
            //console.log('cache insufficient', val, val && val.twix && val.twix(acceptablePreviousTime).length('seconds'), ' seconds');

            return false;
          }

          currDate.add(1, 'days');
        }

        return true;
      }

      function canUseCacheForNote(note) {
        if (note.notes_relations && note.notes_relations.length > 0) {
          return lodash.some(note.notes_relations, function(nr) {
            return canUseCacheForRange(nr.start_date, nr.end_date);
          })
        } else {
          return false;
        }
      }

      this.getRxSubject = function() {
        return rxSubject;
      };

      function filterNotesForTwix(twx, records) {
        return lodash.filter(records, function(record) {
          return lodash.some(record.notes_relations, function(nr) {
            if (!nr.start_date && !nr.range_twix) {
              return false;
            }
            if (nr.start_date.isSame(nr.end_date, 'second')) {
              return twx.contains(nr.start_date);
            } else {
              return nr.range_twix.overlaps(twx) &&
              Math.abs(nr.range_twix.intersection(twx).length('minutes')) > 0;
            }
          }) && !record.deleted_at; // deleted_at must be NULL
        });
      }

      this.getNotesBetweenFromCache = function(startTime, endTime) {
        var range_twix = moment(startTime).twix(moment(endTime));
        return filterNotesForTwix(range_twix, recordsDikt);
      };

      this.addOrReplaceRecord = function(record) {
        // as of right now whether it is NEW or an UPDATE doesn't matter
        var replies = record.replies;

        if (replies && replies.length > 0) {
          lodash.each(replies, function(reply) {
            repliesDikt[reply.id] = reply;
          });

          //SATODO: make this recursive to work with nested trees of replies
          record._reply_ids = lodash.map(replies, 'id');
          record.replies = undefined;
        }

        if (record.$isReply()) {
          repliesDikt[record.id] = record;
        } else {
          recordsDikt[record.id] = record;
        }

        //send it down the updateSubscribers channel
        rxSubject.onNext(record);
      };

      this.addOrReplaceRecords = function(records) {
        lodash.each(records, that.addOrReplaceRecord);
      };

      this.updateCache = function(startDate, endDate, records) {
        var currDate = moment(startDate);
        var newTime = moment.utc();
        while (currDate.isBefore(endDate)) {
          cacheAgeByDate[currDate.format(cacheAgeKeyFormat)] = newTime.clone();

          currDate.add(1, 'days');
        }

        that.addOrReplaceRecords(records);
        return true;
      };

      this.getNotesIntersectingDate = function(dt) {
        return that.getNotesForTwix(TimeService.getDayTwixFromDate(dt));
      };

      this.getByNoteId = function(noteId) {
        var deferred = $q.defer();
        var record = recordsDikt[noteId] || repliesDikt[noteId];

        if (record && canUseCacheForNote(record)) {
          deferred.resolve(record);
        } else {
          Notes.getById(noteId)
            .then(function(note) {
              that.addOrReplaceRecord(note);
              deferred.resolve(note);
            }, function(response) {
              deferred.reject(response);
            });
        }


        return deferred.promise;
      };

      this.destroyNote = function(noteId) {
        Notes.destroy(noteId)
          .then(function(deletedNote) {
            // do the replacement so that we can see deleted_at propagated
            if (deletedNote.parent_id) {
              // a reply was deleted
              that.addOrReplaceRecord(deletedNote);

              lodash.remove(repliesDikt, function(rec) { return rec.id === noteId; });

            } else {
              that.addOrReplaceRecord(deletedNote);
              lodash.remove(recordsDikt, function(rec) { return rec.id === noteId; });
            }
          }, function(response) {
            return $q.reject(response);
          });
      };

      this.getNotesWithFilter = function(options) {
        var params = {};
        var twx = null;

        if (options.start_date && options.end_date) {
          params.start_date = TimeService.getBeginningOfDayFromDate(options.start_date);
          params.end_date = moment(TimeService.getBeginningOfDayFromDate(options.end_date)).add(1, 'days');
          twx = params.start_date.twix(params.end_date);
        }

        if (options.tags) {
          params.tags = options.tags.join(',');
        }
        if (options.obj && options.obj_id) {
          params.mode = 'attached';
          params.subject = options.obj + '-' + options.obj_id;
        } else if (options.obj === "Position" || options.obj === "User" || options.obj === "WorkPeriod") {
          params.mode = 'attached';
          params.subject = options.obj;
        }

        if (options.created_by) {
          params.created_by = options.created_by;
          if (options.replies_only) {
            params.replies_only = options.replies_only;
          }
        }

        return Notes.getAll(params)
          .then(function(notes) {
            that.addOrReplaceRecords(notes);

            return (twx) ? filterNotesForTwix(twx, notes) : notes;
          }, function(response) {
            return $q.reject(response);
          });
      };

      this.getNotesForTwix = function(twx, forceRequest) {
        var startDate = TimeService.getBeginningOfDayFromDate(twx.start);
        // go to the end of the following day, just to make sure we include everything with dayStartHour
        var endDate = TimeService.getBeginningOfDayFromDate(twx.end).add(1, 'days');

        var canUseCache = !forceRequest && canUseCacheForRange(startDate, endDate);
        var deferred = $q.defer();

        if (canUseCache) {
          $timeout(function() {
            deferred.resolve(that.getNotesBetweenFromCache(twx.start, twx.end));
          }, 0);
        } else {

          var callback = function(startTime, endTime) {
            if (startDate) {
              deferred.resolve(that.getNotesBetweenFromCache(startTime, endTime));
            } else {
              deferred.reject();
            }
          };

          createOrAddRequestToBatch(createDataRequest(twx.start, twx.end, callback));
        }

        return deferred.promise;
      };

      this.getNotesForObjWithDate = function(obj, objId, startTimeOrTwix, endTime) {
        var twx;
        objId = !!objId ? objId.toString() : null;

        if (!endTime) {
          twx = startTimeOrTwix;
        } else {
          twx = moment(startTimeOrTwix).twix(moment(endTime));
        }

        var deferred = $q.defer();

        that.getNotesForTwix(twx)
          .then(function(notes) {
            deferred.resolve(lodash.filter(notes, function(note) {
              return lodash.some(note.notes_relations, function(nr) {
                // objId can be null (falsy) or match directly, in addition to obj match
                return (!objId || nr.obj_id === objId) && nr.obj === obj;
              });
            }));
          }, function() {
            deferred.reject();
          });

        return deferred.promise;
      };

      this.updateNote = function(noteData) {
        return Notes.update(noteData)
          .then(function(newNote) {
            that.addOrReplaceRecord(newNote);
            return $q.resolve(newNote);
          }, function(response) {
            return $q.reject(response);
          });
      };

      this.createNote = function(noteData) {
        return Notes.create(noteData)
          .then(function(newNote) {
            that.addOrReplaceRecord(newNote);
            return $q.resolve(newNote);
          }, function(response) {
            return $q.reject(response);
          });
      };

      this.getUpdateChannelForNote = function(note) {
        return rxSubject.filter(function(n) {
          return note.id === n.id;
        });
      };

      this.getNoteReplyChannelForNoteId = function(parentNoteId) {
        return rxSubject.filter(function(n) {
          return n.parent_id === parentNoteId;
        });
      };

      this.getRepliesForNoteId = function(noteId) {
        var deferred = $q.defer();

        that.getByNoteId(noteId)
          .then(function(note) {
            deferred.resolve(
              lodash.sortBy(lodash.filter(repliesDikt, function(value) {
                // need parent_id to match passed in note and it to not have been deleted
              return value.parent_id === note.id && !value.deleted_at;
              }), function(reply) {
                return reply.created_at.unix();
              })
            );
          }, function(response) {
            deferred.reject(response);
          });

        return deferred.promise;
      };


      this.getNotesForQuery = function(query) {
        var options = {};
        var forceAPIQuery = false;

        if (query.created_by) {
          options.created_by = query.created_by;
          forceAPIQuery = true;

          if (query.replies_only) {
            options.replies_only = query.replies_only;
          }
        }

        if (query.tags && query.tags.length > 0) {
          options.tags = query.tags;
          forceAPIQuery = true;
        }

        if (query.dates) {
          options.start_date = query.dates.start;
          options.end_date = query.dates.end;
        } else if (query.cache_locale) {
          options.start_date = query.cache_locale.start;
          options.end_date = query.cache_locale.end;
        } else {
          forceAPIQuery = true;
        }

        if (query.obj && query.obj !== 'date') {
          options.obj = query.obj;

          if (query.obj_id) {
            options.obj_id = query.obj_id;
          }
        }
        // console.log('forceAPIQuery', forceAPIQuery, query, options);

        if (forceAPIQuery) {
          return that.getNotesWithFilter(options);
        } else {
          if (options.obj) {
            // console.log('with obj', options.obj, moment(options.start_date));
            return that.getNotesForObjWithDate(options.obj, options.obj_id, moment(options.start_date).twix(options.end_date));
          } else {
            // console.log('without obj', options.obj, moment(options.start_date));
            return that.getNotesForTwix(moment(options.start_date).twix(options.end_date));
          }
        }
      };

  }]);
